"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const formik_1 = require("formik");
const sites_1 = require("@/store/ducks/sites");
const selectors_1 = require("@/store/ducks/sites/selectors");
const selectors_2 = require("@/store/ducks/sites/selectors");
const schema_1 = require("../../SiteForms/schema");
const index_view_1 = __importDefault(require("../../SiteForms/index.view"));
const createSiteUseCase_1 = require("@/useCases/sites/createSiteUseCase");
function openAddSiteModal() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const isAddSiteModalVisible = (0, react_redux_1.useSelector)(selectors_1.isAddSiteModalOpenSelector);
    const sitesOptions = (0, react_redux_1.useSelector)(selectors_2.sitesListOptionsSelector);
    const isLoading = (0, react_redux_1.useSelector)(selectors_1.isCreatingSiteSelector);
    const onCloseModal = react_1.default.useCallback(() => {
        dispatch((0, sites_1.closeAddSiteModal)());
    }, [dispatch, sites_1.closeAddSiteModal]);
    const initialValues = {
        name: "",
        location: ""
    };
    const onSubmit = (values) => {
        (0, createSiteUseCase_1.createSiteUseCase)(values.name, values.location)(dispatch);
    };
    return (react_1.default.createElement(formik_1.Formik, { initialValues: initialValues, enableReinitialize: true, validationSchema: schema_1.validationSchema, onSubmit: onSubmit }, (props) => {
        return (react_1.default.createElement(index_view_1.default, { formTitle: "Add New Site", onBlur: props.handleBlur, values: props.values, options: sitesOptions, setFieldValue: props.setFieldValue, onSubmit: props.handleSubmit, errors: props.errors, confirmActionText: "Add New Site", touched: props.touched, isLoading: isLoading, onChange: props.handleChange, onClose: onCloseModal, isOpen: isAddSiteModalVisible }));
    }));
}
exports.default = openAddSiteModal;
